/* Informazioni dei movimenti selezionata per la visualizzazione del grafico
null | {"value": plot_info, ...}
*/
import { createContext } from "react";
const selectedPlotInfoContext = createContext({
    selectedPlotInfo: null,
    setSelectedPlotInfo: (type) => {}
  });
export default selectedPlotInfoContext;